module.exports = __webpack_public_path__ + "static/media/patient.6c425534.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/dashboard-icons/patient.svg
// module id = 2117
// module chunks = 0